<!--
 * @Author: 
 * @Date: 2020-04-13 17:44:36
 * @LastEditors: 
 * @LastEditTime: 
 * @Description: file content
 -->
<template>
  <div class="index">
    <div class="index-bg">
      <div class="logo">
        <img
          :src="imgHost + 'logo.png'"
        />
      </div>
      <div class="slogan">
        <img
          :src="imgHost + 'slogan.png?v=1'"
        />
      </div>
      <div class="voice-msg" @click="changeMsg">
        <div class="msg-info">
          {{ dialog.voiceText }}
          <div class="msg-info-tip">（点击即可切换语句）</div>
        </div>
      </div>
      <div
        class="voice-bg"
        @touchstart.stop.prevent="startVoice()"
        @touchend.stop.prevent="endVoice()"
      ></div>
      <div class="long-read">长按麦克风图标朗读</div>
      <div class="gameCount">游戏次数：<span>{{ gameCount }}</span></div>

      <div class="voice-pop-layer" v-show="showVoiceIng">
        <img src="http://assets.rurushishi.com/activies/mfAct/voice.png" />
        <img
          src="http://assets.rurushishi.com/activies/jbAct/voice.gif"
          alt
          class="gif"
        />
      </div>
      <div class="friend-info">
        <div
          class="friend-content"
          v-for="(item, index) in friends"
          :key="index"
        >
          <div class="friend-msg">
            <div class="voice-imgurl">
              <img :src="item.headImg" alt />
            </div>
            <div class="voice-process" @click="playAudio(item, index)">
              <img
                :src="imgHost + 'voice.png'"
                alt
              />
              <div class="yuan" v-show="item.unread"></div>
            </div>
          </div>
          <div class="voice-info">
            {{ item.unread ? "(点击读取语音)" : "(已读)" }}
          </div>
        </div>
      </div>
      <BaseBtnHome></BaseBtnHome>
    </div>
  </div>
</template>

<script>
// import { MessageBox } from "mint-ui";
import { Toast, Indicator, MessageBox } from "mint-ui";
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogList: [],
      dialog: {
        voiceText: "",
      },
      choice: true,
      showVoiceIng: false,
      voice: {
        localId: "",
        time: "",
      },
      animate: false,
      mobile: "",
      name: "",
      gameCount: 0,
      friends: [],
      type: 1, // 默认语音类型
      playVoice: true
    };
  },

  filters: {},
  watch: {},
  computed: {},
  methods: {
    async getGameCount(){
      const data = await this.$httpdf.get(this.apiHost + 'user/voiceCount')
      if (data.code == 0) {
        this.gameCount = data.data.voiceCount
      }
    },
    // 参与游戏
    async selectFriendVoiceInfo() {
      const data = await this.$httpdf.post(this.apiHost + 'voice/selectFriendVoiceInfo')
      if (data.code == 0) {
        this.friends = data.data.map(v=> {
          v.unread = true
          return v
        })
      }
    },
    // 点击切换信息
    async changeMsg() {
      // 随机产生一条语音
      Indicator.open("加载中...");
      const data = await this.$httpdf.post(this.apiHost + 'voice/getVoiceTextInfo')
      Indicator.close();
      if (data.code == 0) {
        this.dialog = data.data
      } else {
        return MessageBox.alert(
          "活动已结束，感谢您的参与，点击我的奖品进行兑奖"
        )
      }
    },
    // 开始读语音
    startVoice() {
      if (this.gameCount == 0) {
        this.$showModal(
          "啊哦～您的朗读次数已用完，快去传播活动找好友帮忙获取更多机会吧！"
        ).then(() => {
          this.showVoiceIng = false;
          this.toGroup();
        });
        return;
      }
      // window.ConfigAudio.pause();
      this.$audio.bg.pause();
      this.showVoiceIng = true;
      this.stime = Date.parse(new Date());
      //开始录音
      let that = this;
      this.$wx.sdk.startRecord({
        // 用户拒绝授权录音
        cancel: function () {
          that.showVoiceIng = false;
          that.$showModal("用户拒绝授权录音", "提示");
        },
      });
      //监听录音自动停止
      this.$wx.sdk.onVoiceRecordEnd({
        complete: function (res) {
          that.showVoiceIng = false;
          that.voice.localId = res.localId;
          that.$showModal(res, "提示");
        },
      });
      return false;
    },
    // 结束读语音
    endVoice() {
      if (this.gameCount == 0) {
        this.$showModal(
          "啊哦～您的朗读次数已用完，快去传播活动找好友帮忙获取更多机会吧！"
        ).then(() => {
          this.showVoiceIng = false;
          this.toGroup();
        });
        return;
      }
      console.log("endVoice");
      let that = this;
      this.$wx.sdk.stopRecord({
        success: function (res) {
          // alert("stopRecord Success");
          // alert(JSON.stringify(res));
          that.voice.localId = res.localId;
          that.showVoiceIng = false;
          that.recognitionVoice();
        },
        fail: function (res) {
          // alert("stopRecord fail");
          // alert(JSON.stringify(res));
          that.showVoiceIng = false;
          that.$showModal(res, "提示");
        },
      });
    },
    // 识别判断
    recognitionVoice() {
      this.translateVoice().then((translateResultTxt) => {
        this.voice.voiceText = translateResultTxt;
        this.textMatch(this.dialog.voiceText, translateResultTxt).then(
          (isMatch) => {
            if (isMatch) {
              this.uploadVoice().then(() => {
                this.gameMatch()
              })
            }
          }
        );
      });
    },
    // 识别语音
    translateVoice() {
      return new Promise((resolve) => {
        this.etime = Date.parse(new Date());
        let time = (this.etime - this.stime) / 1000;
        if (time <= 0) {
          time = 1;
        }
        this.voice.time = time;
        this.$wx.sdk.translateVoice({
          localId: this.voice.localId,
          complete: function (res) {
            if (res.hasOwnProperty("translateResult")) {
              let translateResultTxt = res.translateResult.split("。")[0];
              resolve(translateResultTxt);
            } else {
              Toast({
                message:
                  "要字正腔圆哦，再试一次！精美礼品已迫不及待，等你带走！",
                duration: 1000,
              });
              setTimeout(() => {
                this.$audio.bg.play();
              }, 1000);
            }
          },
        });
      });
    },
    textMatch(txt1, txt2) {
      return new Promise((resolve) => {
        console.log(txt1);
        console.log(txt2);
        resolve(true);
      });
    },
    uploadVoice() {
      return new Promise((resolve) => {
        let that = this;
        this.$wx.sdk.uploadVoice({
          localId: this.voice.localId,
          success: function (res) {
            that.voice.serverId = res.serverId;
            resolve();
          },
        });
      });
    },
   async gameMatch() {
      console.log(this.voice.serverId, this.dialog.id, this.voice.voiceText);
      const data = await this.$httpdf.post(this.apiHost + 'voice/match', {
        mediaId: this.voice.serverId,
        voiceId: this.dialog.id,
        voiceMatchText: this.voice.voiceText,
      })
      if (data.code == 0) {
        Toast({
          message: "恭喜您朗读成功！获得一次抽奖机会!",
          duration: 1000,
        });
        setTimeout(() => {
          this.$audio.bg.play();
          this.$goPage("draw");
        }, 1000);
      } else {
        if (data.msg) {
          Toast({
            message: data.msg,
            duration: 1000,
          });
          this.getGameCount();
        } else {
          Toast({
            message:
              "要字正腔圆哦，再试一次！精美礼品已迫不及待，等你带走！",
            duration: 1000,
          });
        }
      }
    },
    // 播放语音
    playAudio(item, index) {
      if (!this.playVoice) {
        return
      }
      this.playVoice = false
      let that = this;
      that.$audio.bg.pause();
      window.ConfigAudio = new Audio();
      console.log(window.ConfigAudio);
      window.ConfigAudio.src = item.voiceUrl;
      window.ConfigAudio.play({ loop: false, src: item.voiceUrl }, () => {});
      let friends = that.friends;
      // console.log("111")
      friends[index].unread = false;
      that.friends = { ...friends };
      window.ConfigAudio.addEventListener("ended", function () {
        that.$audio.bg.play();
        that.playVoice = true;
        if (!window.bgAudioIsManualClose) {
          that.$audio.bg.play();
        }
      });
    },
    toGroup() {
      let text = {
        text1: "因为",
        text2: "分享",
        text3: "，所以世界有了光！",
        text4: "好东西必须让更多朋友知道",
      };
      this.$modal.share.alert(text).then((res) => {
        console.log(res);
      });
    },
  },
  created() {
    this.type = this.$route.query.type;
    // console.log()
    this.getGameCount()
    this.selectFriendVoiceInfo();
    this.changeMsg();
    this.$wx.shareCallBackFunList.push("share1", async() => {
      this.$modal.share.close()
      await this.$httpdf.post(this.apiHost + 'share/share')
      this.getGameCount()
    });
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.index {
  background: url($imgHost + 'bg.jpg?v=2') center 0 / 100% no-repeat;
  overflow-x: hidden;
}

.index-bg {
  // background: url($imgHost + 'bg5.png') center bottom / 100% no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  // min-height: 1000px;
  position: relative;
  padding-bottom: 30px;

  .logo {
    padding-top: 20px;
    width: $logoWidth;
  }
  
  .slogan {
    width: $sloganWidth;
    position: relative;
    z-index: 2;
    margin-top: 74px;
  }

  .voice-msg {
    position: relative;
    margin: 20px auto 0;
    width: 270px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0 5px;
    .msg-info {
      font-size: 14px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #F941DD;
      .msg-info-tip {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-top: 10px;
      }
    }

    .info-click {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(194, 52, 56, 1);
      line-height: 20px;
    }
  }

  .voice-bg {
    width: 91px;
    height: 91px;
    margin-top: 36px;
    background-image: url($imgHost + 'sound.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .long-read {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #fff;
    margin-top: 15px;
  }

  .gameCount {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color:#fff;
    margin-top: 10px;
    span {
      color:#fff;
      font-size: 20px;
    }
  }

  .voice-pop-layer {
    position: fixed;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: center;
    -webkit-box-align: center; /* width: 100%; */
    -webkit-user-select: none;
    top: 180px;
    left: 50%;
    margin-left: -12.5%;
    height: 100px;
    width: 25%;
    border-radius: 15px;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    z-index: 9;
  }

  .friend-info {
    width: 345px;
    height: 249px;
    border: 2px solid #FFECFF;
    border-radius: 13px;
    margin-top: 40px;
    padding: 15px 3px 15px 17px;
    overflow-y: scroll;
    box-sizing: border-box;

    .friend-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;

      .friend-msg {
        display: flex;
        justify-content: center;
        align-items: center;

        .voice-imgurl {
          width: 44px;
          height: 44px;
          margin-right: 10px;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .voice-process {
          width: 170px;
          height: 40px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .yuan {
            width: 5px;
            height: 5px;
            background: #F941DD;
            border-radius: 50%;
            position: absolute;
            right: 5px;
            bottom: 5px;
          }
        }
      }

      .voice-info {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fff;
        line-height: 37px;
      }
    }
  }

  .dialog-main {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;

    .dialog-list {
      width: 300px;
      background: #FFFFFF;
      border-radius: 10px;
      padding: 10px 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .dialog-item {
        width: 100%;
        // min-height: 45px;
        padding: 15px 0;
        border-top: solid 1px #E9E9E9;
        display: flex;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #D80D19;

        .dialog-icon {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
      }

      .dialog-item:first-child {
        border-top: none;
      }

      .dialog-info {
        flex: 1;
      }

      .dialog-choice {
        width: 169px;
        height: 34px;
        background: #F15433;
        box-shadow: 0px 3px 2px 0px rgba(142, 61, 43, 0.92);
        border-radius: 17px;
        font-size: 19px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 34px;
        text-align: center;
      }
    }
  }

  .goHome {
    position: fixed;
    bottom: 40px;
    right: 10px;
    width: 72px;
    height: 72px;
    // background: linear-gradient(0deg, rgba(1, 94, 234, 1) 0%, rgba(0, 192, 250, 1) 100%);
    // border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    text-align: justify;
    z-index: 2;
  }

  .goHome img {
    width: 100%;
  }
}
.index-txt {
  margin-top: 10px;
  text-align: center;
  p {
    display: inline-block;
    background: #267C55;
    border-radius: 2px;
    font-size: 14px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FFFFFF;
    padding: 5px;
    margin-bottom: 10px;
  }
}
</style>
